import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
const PIXEL_ID = '949582520795873';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel directly via script injection
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      f.fbq('init', PIXEL_ID);
      f.fbq('track', 'PageView');
    }
  }, []);
  return <LandingPage data-id="element-0" />;
}